module.exports = __webpack_public_path__ + "img/楦头.a15ae097.png";